import { ChartWidgetMetadata } from '@/modules/ta/widget/models/metadata/ChartWidgetMetadata';
import { CombinationChartDrawOption } from '@/modules/ta/widget/models/drawoptions/CombinationChartDrawOption';

export class CombinationChartWidgetMetadata extends ChartWidgetMetadata {
  /**
   * @var {Array}
   */
  line_columns;

  /**
   * Per-metric forecast config keyed by metric field:
   * { [field]: { enabled: boolean, line_style: string } }
   *
   * @var {Object}
   */
  forecast_metrics;

  /**
   * Chart-level forecast config:
   * { horizon_days, method, show_confidence_band, confidence_level }
   *
   * @var {Object}
   */
  forecast_config;

  constructor(model = {}) {
    super(model);

    this.line_columns = model.line_columns || {};
    this.draw_options = new CombinationChartDrawOption(model.draw_options);
    this.initForecastMetadata(model);
  }
}
